import React from 'react'
import Notifications from '../../../Components/UserComponents/Notifications/Notifications'
import Header from '../../../Components/UserComponents/Header/Header';
import Footer from '../../../Components/UserComponents/Footer/Footer';
const NotificationPage = () => {
    return (
        <div>
            <Header />
            <Notifications />
            <Footer />
        </div>
    )
}

export default NotificationPage